cockpitApp.directive('contact', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/contact',
    controllerAs: 'contactCtrl',
    controller: 'contactController'
  };
});
